// extracted by mini-css-extract-plugin
export default {"content":"ProfileBlock_content__YA2LK"};